import { DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import '@angular/localize/init';
import { EcommerceMappersModule } from '@epicuro-next/addons/ecommerce-tracking-mappers';
import { ModalService } from '@epicuro-next/ataraxia/modal';
import {
  BasketReviewService,
  DataBasketsModule,
} from '@epicuro-next/data/baskets';
import { DataDocumentsModule } from '@epicuro-next/data/documents';
import {
  BROWSER_STORAGE_SERVICE,
  BROWSER_STORAGE_TOKEN,
} from '@epicuro-next/platform/storage';
import {
  resetStateMetaReducer,
  storageMetaReducer,
} from '@epicuro-next/state/meta-reducers';
import { SnackbarStateModule } from '@epicuro-next/state/snackbar';
import { StateTrackingModule } from '@epicuro-next/state/tracking';
import { UserStateModule } from '@epicuro-next/state/user-state';
import { UserUiStateModule } from '@epicuro-next/state/user-ui-state';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { BasketAccountsService } from './services/basket-accounts.service';
import { CBasketService } from './services/c-basket.service';
import {
  BASKET_CONFIG_TOKEN,
  BASKET_STORAGE_KEY,
  BASKET_STORAGE_KEYS,
} from './state/basket.tokens';
import {
  BasketAccountsEffects,
  BasketActionsEffects,
  BasketGroupingEffects,
  BasketModalsEffects,
  BasketSentryEffects,
  BasketUiEffects,
  UpdateBasketEffects,
} from './state/effects';
import { BasketDataEffects } from './state/effects/basket-data.effects';
import { BasketInitEffects } from './state/effects/basket-init.effects';
import { BasketManualDiscountsEffects } from './state/effects/basket-manual-discounts.effects';
import { BasketOperationsEffects } from './state/effects/basket-operations.effects';
import { BasketValidationsEffects } from './state/effects/basket-validations.effects';
import { UpdateBasketEcommerceTrackingEffects } from './state/effects/ecommerce-tracking.effects';
import * as fromBasketAccounts from './state/reducers/basket-accounts.reducer';
import { basketFeatureKey, initialState, reducers } from './state/store';

export function getBasketAccountsFactoryConfig(
  saveKeys: string[],
  browserStorageKey: string,
  storageService: BROWSER_STORAGE_SERVICE,
) {
  return {
    metaReducers: [
      storageMetaReducer(saveKeys, browserStorageKey, storageService),
      resetStateMetaReducer(initialState),
    ],
  };
}

@NgModule({
  imports: [
    StoreModule.forFeature(basketFeatureKey, reducers, BASKET_CONFIG_TOKEN),
    EffectsModule.forFeature([
      BasketOperationsEffects,
      BasketActionsEffects,
      BasketGroupingEffects,
      UpdateBasketEffects,
      BasketDataEffects,
      BasketInitEffects,
      BasketAccountsEffects,
      BasketModalsEffects,
      BasketUiEffects,
      BasketSentryEffects,
      UpdateBasketEcommerceTrackingEffects,
      BasketManualDiscountsEffects,
      BasketValidationsEffects,
    ]),
    UserStateModule,
    UserUiStateModule,
    DataBasketsModule,
    DataDocumentsModule,
    SnackbarStateModule,
    StateTrackingModule,
    EcommerceMappersModule,
  ],
  providers: [
    {
      provide: BASKET_STORAGE_KEY,
      useValue: 'basket_storage',
    },
    {
      provide: BASKET_STORAGE_KEYS,
      useValue: [
        `${fromBasketAccounts.basketAccountsFeatureKey}.activeBasketAccounts`,
      ],
    },
    {
      provide: BASKET_CONFIG_TOKEN,
      deps: [BASKET_STORAGE_KEYS, BASKET_STORAGE_KEY, BROWSER_STORAGE_TOKEN],
      useFactory: getBasketAccountsFactoryConfig,
    },
    CBasketService,
    BasketReviewService,
    BasketAccountsService,
    ModalService,
    DecimalPipe,
  ],
})
export class BasketStateModule {}
